<template>
    <div class="fill-height">
        <v-row class="fill-height" justify="center" align="center">
            <v-col cols="auto">
                <v-card class="pa-15 rounded-3xl" max-width="500px" color="surface" elevation="0">
                    <v-row>
                        <v-col cols="12">
                            <v-row align="center" justify="center">
                                <v-col cols="auto">
                                    <v-img max-width="100px" contain src="/images/logo_roxo.png" />
                                </v-col>
                                <v-col cols="12" class="text-center primary--text">
                                    <span class="text-h5">Confirmação de E-mail</span><br>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col v-if="loading" cols="12" class="text-center">
                            <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
                            <div class="mt-4 secondary--text">Validando seu token...</div>
                        </v-col>

                        <template v-else>
                            <v-col v-if="error_message" cols="12">
                                <v-alert type="error" text dense rounded="xl" class="text-center">
                                    {{ error_message }}
                                </v-alert>
                            </v-col>

                            <v-col v-if="success_message" cols="12">
                                <v-alert type="success" text dense rounded="xl" class="text-center">
                                    {{ success_message }}
                                </v-alert>
                            </v-col>

                            <v-col cols="12" class="d-flex justify-center mt-4">
                                <v-btn color="primary" outlined class="rounded-xl" large block elevation="0" @click="goToLogin">
                                    Ir para o Login
                                </v-btn>
                            </v-col>
                        </template>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    data() {
        return {
            loading: true,
            error_message: null,
            success_message: null,
        };
    },
    mounted() {
        this.verifyEmail();
    },
    methods: {
        ...mapActions("auth", ["ActionVerifyEmail"]),
        async verifyEmail() {
            const token = this.$route.query.token;

            if (!token) {
                this.error_message = "Token de verificação ausente.";
                this.loading = false;
                return;
            }

            try {
                const response = await this.ActionVerifyEmail({ token });
                this.success_message = response.data.message;
            } catch (error) {
                if (error?.response?.data?.error) {
                    this.error_message = error.response.data.error;
                } else if (error?.response?.data?.message) {
                    this.error_message = error.response.data.message;
                } else {
                    this.error_message = "Ocorreu um erro ao verificar o e-mail.";
                }
            } finally {
                this.loading = false;
            }
        },
        goToLogin() {
            this.$router.push({ name: "auth" });
        }
    }
};
</script>
